import { FC, useCallback, useMemo } from 'react';

import TextareaFieldFormatter from '@payaca/components/textareaField/TextareaFieldFormatter';
import ValidatedForm from '@payaca/components/validatedForm/ValidatedForm';
import EditJobSection from './EditJobSection';

import { FieldValidationResult } from '@payaca/types/fieldValidationTypes';
import { Job } from '@payaca/types/jobTypesV2';

import { getJob } from '@/utils/stateAccessors';

import { useSelector } from '@/api/state';
import { isInvoice } from '@payaca/helpers/jobStatusHelper';
import { useDebounceCallback } from '@payaca/hooks';

type Props = {
  jobId: number;
  updateJob: (
    value: { [key: string]: any },
    onUpdateSuccess?: () => void
  ) => void;
};
const JobAdditionalNotesControl: FC<Props> = ({ jobId, updateJob }: Props) => {
  const job: Job | undefined = useSelector((state) => getJob(state, jobId));

  const debouncedUpdateJob = useDebounceCallback(updateJob, 500, {
    flushOnUnmount: true,
  });

  const initialFormState = useMemo(() => {
    return {
      job: {
        jobNotes: job?.jobNotes,
      },
    };
    // Fixes infinite re-render of ValidatedForm. Also, no need to update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderFormContents = useCallback(
    (
      isValid: boolean,
      formState: {
        [key: string]: any;
      },
      validationState: {
        [key: string]: FieldValidationResult;
      },
      touchedState: {
        [key: string]: boolean;
      },
      onFieldChange: (value: { [key: string]: any }) => void,
      onFieldTouch: (fieldName: string) => void
    ) => {
      return (
        <TextareaFieldFormatter
          name="job.jobNotes"
          value={formState.job?.jobNotes}
          onChange={onFieldChange}
          placeholder={`Give yourself an edge over your competitors by adding additional information to your ${
            !!job && isInvoice(job?.status) ? 'invoice' : 'proposal'
          }.`}
        />
      );
    },
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useCallback has a missing dependency: 'job'
    [job?.status]
  );

  return (
    <EditJobSection title="Notes" className="job-additional-notes-control">
      <ValidatedForm
        renderFormContents={renderFormContents}
        initialFormState={initialFormState}
        onFormStateChange={debouncedUpdateJob}
      />
    </EditJobSection>
  );
};

export default JobAdditionalNotesControl;
